import { TTagging } from 'interface'

import InterWebviewBridge, { interWbSession } from '@interco/inter-webview-bridge'

const params: TTagging = {
  screen: 'Check-in premiado',
  product: 'Ativathon',
  content_action: '',
  action_id: '',
  ref_type: '',
  type: 'CHECKIN_FLUXO',
}
const iWb = InterWebviewBridge.getInstance()

export const tagEvent = ({ type, content_action, screen, ref_type, action_id }: TTagging) => {
  if (['IOS', 'ANDROID'].includes(iWb.getEnvironment())) {
    interWbSession.requestAnalytics(type, {
      product: params.product,
      content_action: content_action || params.content_action,
      screen: screen || params.screen,
      ref_type: ref_type || params.ref_type,
      action_id: action_id || params.action_id,
    })
  }
}
